import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useState } from "react";
import styled, { css, useTheme } from "styled-components";
import { genericColor } from "~/lib/resolvers";
const Wrapper = styled.div`
  ${_ref => {
  let {
    $s,
    theme
  } = _ref;
  return theme.spacing.resolve(theme, $s);
}};
  height: ${_ref2 => {
  let {
    $size,
    theme
  } = _ref2;
  return $size * theme.typography.fontStep;
}}rem;
  width: ${_ref3 => {
  let {
    $size,
    theme
  } = _ref3;
  return $size * theme.typography.fontStep;
}}rem;
  position: relative;
  display: inline-block;
  overflow: hidden;
`;
const Arc = styled.path`
  position: relative;
  transition: stroke-dasharray 1000ms cubic-bezier(0.53, -0.19, 0.4, 1.08),
    stroke-width 300ms cubic-bezier(0.53, -0.19, 0.4, 1.08);
  ${_ref4 => {
  let {
    $hoverable,
    strokeWidth
  } = _ref4;
  return $hoverable && css`
      cursor: help;

      &:hover {
        stroke-width: ${strokeWidth * 2};
        z-index: 2;
      }
    `;
}};
`;
const Svg = styled.svg`
  position: absolute;
  z-index: 1;
  top: 50%;
  width: ${_ref5 => {
  let {
    $scale
  } = _ref5;
  return $scale * 100;
}}%;
  height: ${_ref6 => {
  let {
    $scale
  } = _ref6;
  return $scale * 100;
}}%;
  transform: translate(-50%, -50%);
  left: 50%;
  border-radius: 50%;
`;
const Centered = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
const Doughnut = _ref7 => {
  let {
    size = 20,
    s,
    children,
    contents,
    ...rest
  } = _ref7;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $size: size,
    $s: s
  }, rest), children, !!contents && /*#__PURE__*/React.createElement(Centered, null, contents));
};
Doughnut.Arc = _ref8 => {
  let {
    children,
    width = 5,
    offset = 0,
    scale = 1,
    colors = [],
    opacity = 1,
    labels = [],
    hideBackground = false,
    values = [],
    ...rest
  } = _ref8;
  const theme = useTheme();
  const [animatedWidth, setAnimatedWidth] = useState(0);
  let totalValue = 0;
  useEffect(() => {
    setTimeout(() => setAnimatedWidth(100), 1000);
  }, [values.join(",")]);
  return /*#__PURE__*/React.createElement(Svg, {
    $scale: scale,
    viewBox: "20 20 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "round"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: "1",
    result: "round1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "round1",
    mode: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 20 -14",
    result: "round2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "round2",
    operator: "atop"
  }))), !hideBackground && /*#__PURE__*/React.createElement(Arc, {
    fill: "none",
    strokeWidth: width,
    strokeDasharray: "360 0",
    $hoverable: false,
    strokeDashoffset: "0",
    opacity: 0.2 * opacity,
    stroke: theme.colors.primary.main,
    filter: "url(#round)",
    pathLength: "360",
    d: "M75 50a1 1 90 10-50 0a1 1 90 10 50 0"
  }), values.map((value, index) => {
    const degOffset = offset + totalValue * 360 / 100;
    totalValue += value;
    const degValue = value * 360 / 100;
    if (!degValue) {
      return null;
    }
    return /*#__PURE__*/React.createElement(Arc, _extends({
      key: index,
      "data-tooltip-id": "general-tooltip",
      "data-tooltip-content": labels[index] || undefined,
      $hoverable: !!labels[index],
      opacity: opacity,
      "data-tooltip-float": true,
      fill: "none",
      strokeWidth: width,
      strokeDasharray: `${animatedWidth * degValue / 100} ${360 - degValue * animatedWidth / 100}`,
      strokeDashoffset: -90 + degValue + degOffset,
      stroke: genericColor(theme, colors[index] || "primary"),
      filter: "url(#round)",
      pathLength: 360,
      d: "M75 50a1 1 90 00-50 0a1 1 90 00 50 0"
    }, rest));
  }));
};
Doughnut.displayName = "Doughnut";
Doughnut.Arc.displayName = "DoughnutArc";
export default Doughnut;